import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import alert from '@drivesally/sally-ui/lib/libs/alert';
import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';
import parseError from '@drivesally/sally-fw/lib/error/parseError';
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

import listReposApi from '@drivesally/sally-fn/lib/repo/api/list.api.repo';

import listRecentCallsApi from '../../../aircall/api/listRecentCalls.api.aircall';

import getConversationApi from '../../../chaya/api/getConversation.api.chaya';
import getSuggestedReplyApi from '../../../chaya/api/getSuggestedReply.api.chaya';
import getConnectedAgents from '../../../chaya/lib/getConnectedAgents.lib.chaya';
import orderByDate from '../../../libs/orderByDate';
import api from '../../../libs/everythingFromApi';

import getApiEndpoint from '../../../api/lib/getEndpoint.lib.api';
import getAuthToken from '../../../auth/lib/getAuthToken.lib.auth';

import createTicketNoteApi from '../../api/createTicketNote.api.crm';
import deleteTicketNoteApi from '../../api/deleteTicketNote.api.crm';
import getTicketApi from '../../api/getTicket.api.crm';
import listShortcutsApi from '../../api/listShortcuts.api.crm';
import listTagsApi from '../../api/listTags.api.crm';
import listTeamsApi from '../../api/listTeams.api.crm';
import listTicketNotesApi from '../../api/listTicketNotes.api.crm';
import updateTicketApi from '../../api/updateTicket.api.crm';

import CrmTicketModal from '../../components/CrmTicketModal/CrmTicketModal';

import agentConnectionsUpdatedEvent from '../../events/agentConnectionsUpdated.event.crm';
import showTicketDetailsEvent from '../../events/showTicketDetails.event.crm';
import ticketUpdatedEvent from '../../events/ticketUpdated.event.crm';
import tagChangedEvent from '../../events/tagChanged.event.crm';

import getUserTeamIds from '../../lib/getUserTeamIds.lib.crm';
import isShortcutAvailable from '../../lib/isShortcutAvailable.lib.crm';
import hasDriverActiveRepo from '../../../repo/lib/hasDriverActiveRepo.lib.repo';

const MAX_ACTIVE_AGENTS = 10;

class CrmTicketDetailsContainer extends Component {
  static propTypes = {
    subscribe: PropTypes.func,
    userData: PropTypes.object,
  };

  state = {
    aircallCalls: [],
    aircallLoading: false,
    assignedTeamId: '',
    chayaConvoId: null,
    connectedAgents: [],
    conversationLoading: false,
    conversationMessages: [],
    creatingNote: false,
    hasActiveDeactivation: false,
    loading: false,
    newNoteText: '',
    notes: [],
    notesLoading: false,
    saving: false,
    savingNoteIds: [],
    savingTitle: false,
    selectedTagIds: [],
    shortcuts: [],
    state: 'open',
    suggestedReplies: [],
    suggestedRepliesConvoId: null,
    suggestedRepliesLoading: false,
    tags: [],
    teams: [],
    saveReady: false,
    ticket: null,
    visible: false,
    wsConnected: false,
  };

  componentDidMount() {
    this.mounted = true;
    this.saveRequestId = 0;
    this.suggestedRepliesRequestId = 0;
    this.pendingSuggestedRepliesConvoId = null;
    this.titleSaveRequestId = 0;
    this.props.subscribe(
      showTicketDetailsEvent.subscribe(this.show),
      tagChangedEvent.subscribe(this.loadTags),
      agentConnectionsUpdatedEvent.subscribe(this.onAgentConnectionsUpdated)
    );
  }

  componentWillUnmount() {
    this.mounted = false;
    clearTimeout(this.messageFlushTimer);
    if (this.ws) this.ws.close();
  }

  show = (ticket) => {
    this.setState(
      {
        aircallCalls: [],
        aircallLoading: !!fkOrId(ticket?.driver),
        visible: true,
        ticket,
        chayaConvoId: ticket?.chaya_convo_id || null,
        connectedAgents: [],
        conversationLoading: !!ticket?.chaya_convo_id,
        conversationMessages: [],
        hasActiveDeactivation: false,
        state: ticket?.state || 'open',
        assignedTeamId: ticket?.assigned_team
          ? `${fkOrId(ticket.assigned_team)}`
          : '',
        selectedTagIds: [...(ticket?.tags || [])].map((tag) => fkOrId(tag)),
        saveReady: false,
        notes: [],
        newNoteText: '',
        ...this.emptySuggestedReplies(),
        suggestedRepliesLoading: !!ticket?.chaya_convo_id,
      },
      () => {
        this.loadTicketDetails();
        this.loadSuggestedReplies();
      }
    );
  };

  hide = () => {
    const {loading, saving, savingTitle} = this.state;
    if (loading || saving || savingTitle) return;
    if (this.ws) this.ws.close();
    this.setState({
      aircallCalls: [],
      aircallLoading: false,
      visible: false,
      ticket: null,
      chayaConvoId: null,
      connectedAgents: [],
      conversationLoading: false,
      conversationMessages: [],
      hasActiveDeactivation: false,
      saveReady: false,
      notes: [],
      newNoteText: '',
      shortcuts: [],
      wsConnected: false,
      ...this.emptySuggestedReplies(),
    });
  };

  emptySuggestedReplies = () => {
    this.suggestedRepliesRequestId += 1;
    this.pendingSuggestedRepliesConvoId = null;
    return {
      suggestedReplies: [],
      suggestedRepliesConvoId: null,
      suggestedRepliesLoading: false,
    };
  };

  loadSuggestedReplies = async ({force = false, conversationId} = {}) => {
    const convoId =
      conversationId !== undefined ? conversationId : this.state.chayaConvoId;
    if (!convoId) return;
    if (!force && `${this.pendingSuggestedRepliesConvoId}` === `${convoId}`)
      return;
    if (!force && `${this.state.suggestedRepliesConvoId}` === `${convoId}`)
      return;

    const requestId = ++this.suggestedRepliesRequestId;
    this.pendingSuggestedRepliesConvoId = `${convoId}`;
    this.setState({suggestedRepliesLoading: true});
    try {
      const response = await getSuggestedReplyApi({
        conversationId: convoId,
      });
      if (!this.mounted || requestId !== this.suggestedRepliesRequestId) return;
      this.setState({
        suggestedReplies: response?.suggestions || [],
        suggestedRepliesConvoId: convoId,
        suggestedRepliesLoading: false,
      });
    } catch (error) {
      if (!this.mounted || requestId !== this.suggestedRepliesRequestId) return;
      if (`${this.pendingSuggestedRepliesConvoId}` === `${convoId}`)
        this.pendingSuggestedRepliesConvoId = null;
      const {message} = parseError(error);
      alert.error(message);
      this.setState({suggestedReplies: [], suggestedRepliesLoading: false});
    }
  };

  refreshSuggestedReplies = () => this.loadSuggestedReplies({force: true});

  getDriverRepos = async (driverId) => {
    if (!driverId) return [];
    try {
      return await api(listReposApi, {
        driver: driverId,
        ordering: '-created_at',
      });
    } catch (error) {
      return [];
    }
  };

  loadTicketDetails = async () => {
    const {ticket} = this.state;
    if (!ticket?.id) return;

    this.setState({loading: true, conversationLoading: true, saveReady: false});
    try {
      const driverId = fkOrId(ticket?.driver);
      const [
        tagsResponse,
        teamsResponse,
        shortcutsResponse,
        fullTicket,
        repos,
      ] = await Promise.all([
        listTagsApi({limit: 1000, ordering: 'tag'}),
        listTeamsApi({limit: 100, ordering: 'name'}),
        listShortcutsApi({limit: 1000, ordering: 'name'}),
        getTicketApi(ticket.id),
        this.getDriverRepos(driverId),
      ]);
      if (!this.mounted) return;

      const chayaConvoId = fullTicket?.chaya_convo_id || null;
      this.setState({
        loading: false,
        tags: tagsResponse.results,
        teams: teamsResponse.results,
        shortcuts: shortcutsResponse.results || [],
        ticket: fullTicket,
        chayaConvoId,
        hasActiveDeactivation: hasDriverActiveRepo(repos),
        assignedTeamId: fullTicket?.assigned_team
          ? `${fkOrId(fullTicket.assigned_team)}`
          : '',
        selectedTagIds: [...(fullTicket?.tags || [])].map((tag) => fkOrId(tag)),
        state: fullTicket?.state || 'open',
        saveReady: true,
      });
      if (chayaConvoId) {
        this.loadSuggestedReplies({conversationId: chayaConvoId});
      } else if (this.pendingSuggestedRepliesConvoId) {
        this.suggestedRepliesRequestId += 1;
        this.pendingSuggestedRepliesConvoId = null;
        this.setState({
          suggestedReplies: [],
          suggestedRepliesConvoId: null,
          suggestedRepliesLoading: false,
        });
      }
      await Promise.all([
        this.loadConversation(chayaConvoId),
        this.loadNotes(fullTicket.id),
        this.loadRecentCalls(fkOrId(fullTicket?.driver)),
      ]);
    } catch (error) {
      if (!this.mounted) return;
      alert.info(`Failed to load CRM ticket details: ${error}`);
      this.setState({
        aircallCalls: [],
        aircallLoading: false,
        loading: false,
        conversationLoading: false,
        hasActiveDeactivation: false,
        notesLoading: false,
        tags: [],
        teams: [],
        shortcuts: [],
      });
    }
  };

  loadNotes = async (ticketId) => {
    if (!ticketId) {
      if (!this.mounted) return;
      this.setState({notes: [], notesLoading: false});
      return;
    }

    this.setState({notesLoading: true});
    try {
      const response = await listTicketNotesApi(ticketId, {limit: 1000});
      if (!this.mounted) return;
      const notes = response?.results || response || [];
      this.setState({notes, notesLoading: false});
    } catch (error) {
      if (!this.mounted) return;
      this.setState({notes: [], notesLoading: false});
    }
  };

  loadRecentCalls = async (driverId) => {
    if (!driverId) {
      if (!this.mounted) return;
      this.setState({aircallCalls: [], aircallLoading: false});
      return;
    }

    this.setState({aircallLoading: true});
    try {
      const response = await listRecentCallsApi(driverId);
      if (!this.mounted) return;
      const calls = response?.results || response || [];
      this.setState({
        aircallCalls: orderByDate(calls, 'started_at', 'desc'),
        aircallLoading: false,
      });
    } catch (error) {
      if (!this.mounted) return;
      this.setState({aircallCalls: [], aircallLoading: false});
    }
  };

  loadConversation = async (conversationId) => {

    if (!conversationId) {
      if (!this.mounted) return;
      this.setState({
        connectedAgents: [],
        conversationLoading: false,
        conversationMessages: [],
      });
      return;
    }

    this.setState({conversationLoading: true, conversationMessages: []});
    try {
      const results = await getConversationApi({conversationId});
      if (!this.mounted) return;
      this.setState({
        connectedAgents: getConnectedAgents(results),
        conversationLoading: false,
        conversationMessages: orderByDate(
          results?.messages || [],
          'created_at',
          'asc'
        ),
      });
    } catch (error) {
      if (!this.mounted) return;
      this.setState({
        connectedAgents: [],
        conversationLoading: false,
        conversationMessages: [],
      });
    }
  };

  onAgentConnectionsUpdated = (data) => {
    const {chayaConvoId} = this.state;
    if (!chayaConvoId || `${data?.conversation_id}` !== `${chayaConvoId}`) return;

    this.setState({
      connectedAgents: getConnectedAgents({
        agent_connections: data.agent_connections,
      }),
    });
  };

  loadTags = async () => {
    if (!this.state.visible) return;
    try {
      const {results} = await listTagsApi({limit: 1000, ordering: 'tag'});
      if (!this.mounted) return;
      this.setState({tags: results});
    } catch (error) {
      if (!this.mounted) return;
    }
  };

  onStateChange = (state) => {
    this.persistTicket({state});
  };

  onTeamChange = (assignedTeamId) => {
    this.persistTicket({assignedTeamId});
  };

  onTitleSave = async (title) => {
    const {loading, saveReady, savingTitle, ticket} = this.state;
    if (!saveReady || loading || savingTitle || !ticket?.id) return;

    const requestId = ++this.titleSaveRequestId;
    this.setState({savingTitle: true});
    try {
      const response = await updateTicketApi(ticket.id, {title});
      if (!this.mounted || requestId !== this.titleSaveRequestId) return;
      this.setState({savingTitle: false, ticket: response});
      ticketUpdatedEvent.publish(response);
    } catch (error) {
      if (!this.mounted || requestId !== this.titleSaveRequestId) return;
      const {message} = parseError(error);
      alert.error(message);
      this.setState({savingTitle: false});
    }
  };

  onTagToggle = (tagId) => () => {
    const {selectedTagIds} = this.state;
    const next = selectedTagIds.includes(tagId)
      ? selectedTagIds.filter((id) => id !== tagId)
      : [...selectedTagIds, tagId];
    this.persistTicket({selectedTagIds: next});
  };

  onApplyShortcutTags = (shortcut) => {
    const shortcutTagIds = [...(shortcut?.tags || [])]
      .map((tag) => fkOrId(tag))
      .filter(Boolean);
    if (!shortcutTagIds.length) return;

    const {selectedTagIds} = this.state;
    const next = [...selectedTagIds];
    shortcutTagIds.forEach((tagId) => {
      if (!next.includes(tagId)) next.push(tagId);
    });
    if (next.length === selectedTagIds.length) return;

    this.persistTicket({selectedTagIds: next});
  };

  onDeleteNote = async (noteId) => {
    const {ticket} = this.state;
    if (!ticket?.id) return;

    this.setState({
      savingNoteIds: [...this.state.savingNoteIds, noteId],
    });
    try {
      await deleteTicketNoteApi(ticket.id, noteId);
      if (!this.mounted) return;
      this.setState({
        notes: this.state.notes.filter((note) => note.id !== noteId),
        savingNoteIds: this.state.savingNoteIds.filter((id) => id !== noteId),
      });
    } catch (error) {
      if (!this.mounted) return;
      const {message} = parseError(error);
      alert.error(message);
      this.setState({
        savingNoteIds: this.state.savingNoteIds.filter((id) => id !== noteId),
      });
    }
  };

  onNewNoteTextChange = (newNoteText) => {
    this.setState({newNoteText});
  };

  onCreateNote = async () => {
    const {newNoteText, ticket} = this.state;
    const text = newNoteText.trim();
    if (!ticket?.id || !text) return;

    this.setState({creatingNote: true});
    try {
      const response = await createTicketNoteApi(ticket.id, {text});
      if (!this.mounted) return;
      this.setState({
        creatingNote: false,
        newNoteText: '',
        notes: [...this.state.notes, response],
      });
    } catch (error) {
      if (!this.mounted) return;
      const {message} = parseError(error);
      alert.error(message);
      this.setState({creatingNote: false});
    }
  };

  persistTicket = async (overrides = {}) => {
    const {assignedTeamId, loading, saveReady, saving, selectedTagIds, state, ticket} = this.state;
    if (!saveReady || loading || saving || !ticket?.id) return;

    const nextState = overrides.state ?? state;
    const nextAssignedTeamId = overrides.assignedTeamId ?? assignedTeamId;
    const nextSelectedTagIds = overrides.selectedTagIds ?? selectedTagIds;

    const requestId = ++this.saveRequestId;
    this.setState({saving: true});
    try {
      const response = await updateTicketApi(ticket.id, {
        state: nextState,
        assigned_team: nextAssignedTeamId ? Number(nextAssignedTeamId) : null,
        tags: nextSelectedTagIds,
        // Closing a ticket should also close its linked Chaya conversation, if any.
        ...(nextState === 'closed' ? {close_conversation: true} : {}),
      });
      if (!this.mounted || requestId !== this.saveRequestId) return;
      this.setState({
        saving: false,
        state: nextState,
        assignedTeamId: nextAssignedTeamId,
        selectedTagIds: nextSelectedTagIds,
        ticket: response,
      });
      ticketUpdatedEvent.publish(response);
    } catch (error) {
      if (!this.mounted || requestId !== this.saveRequestId) return;
      const {message} = parseError(error);
      alert.error(message);
      this.setState({saving: false});
    }
  };

  buildWsUrl = (conversationId) => {
    const apiUrl = getApiEndpoint('chaya');
    const parsed = new URL(apiUrl);
    const protocol = parsed.protocol === 'https:' ? 'wss' : 'ws';
    return `${protocol}://${parsed.host}/ws/agent/conversations/${conversationId}/`;
  };

  handleWsConnect = async () => {
    const {chayaConvoId} = this.state;

    try {
      const conversation = await getConversationApi({conversationId: chayaConvoId});
      if ((conversation?.active_agents || 0) >= MAX_ACTIVE_AGENTS) {
        alert.error('The maximum number of active agents is already talking with this user.');
        return;
      }
    } catch (error) {
      alert.error('Failed to check conversation status before connecting.');
      return;
    }

    if (this.ws) this.ws.close();
    this.messageBuffer = [];
    this.setState({conversationMessages: []});

    const ws = new WebSocket(this.buildWsUrl(chayaConvoId));
    this.ws = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({type: 'agent_auth', token: getAuthToken('chaya')}));
      if (this.ws !== ws) return;
      this.setState({wsConnected: true});
    };

    ws.onmessage = ({data}) => {
      if (this.ws !== ws) return;
      try {
        const frame = JSON.parse(data);
        if (frame.type === 'typing') return;
        const message = {
          id: frame.id,
          author: frame.author,
          text: frame.text,
          type: frame.type,
          agent: frame.agent,
          created_at: frame.created_at,
          driver_read_at: frame.driver_read_at,
        };
        this.messageBuffer.push(message);
        clearTimeout(this.messageFlushTimer);
        this.messageFlushTimer = setTimeout(() => {
          const buffered = this.messageBuffer;
          this.messageBuffer = [];
          if (!this.mounted) return;
          this.setState((prev) => ({
            conversationMessages: [...prev.conversationMessages, ...buffered],
          }));
        }, 50);
      } catch (e) {
        // ignore malformed frames
      }
    };

    ws.onclose = () => {
      if (this.ws !== ws || !this.mounted) return;
      this.setState({wsConnected: false});
    };

    ws.onerror = () => {
      if (this.ws !== ws || !this.mounted) return;
      this.setState({wsConnected: false});
    };
  };

  handleWsDisconnect = () => {
    clearTimeout(this.messageFlushTimer);
    this.messageBuffer = [];
    if (this.ws) this.ws.close();
  };

  handleSend = (text) => {
    if (!text || !this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    this.ws.send(JSON.stringify({type: 'txt', message: text}));
  };

  handleSendFile = (doc) => {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;

    let ttl = null;
    try {
      const expires = new URL(doc.document_file).searchParams.get('Expires');
      if (expires) ttl = parseInt(expires, 10);
    } catch (_) {}

    const MIME_TYPES = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      webp: 'image/webp',
      svg: 'image/svg+xml',
      mp4: 'video/mp4',
      zip: 'application/zip',
    };
    const mime_type = MIME_TYPES[doc.file_format] || MIME_TYPES[doc.file_extension] || '';

    this.ws.send(JSON.stringify({
      type: 'file',
      url: doc.document_file,
      name: doc.name,
      mime_type,
      ...(ttl != null ? {ttl} : {}),
    }));
  };

  availableShortcuts = () => {
    const {shortcuts, teams} = this.state;
    const userId = this.props.userData?.id;
    const userTeamIds = getUserTeamIds(teams, userId);

    return [...shortcuts]
      .filter((shortcut) =>
        isShortcutAvailable(shortcut, {userId, userTeamIds})
      )
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  };

  render() {
    const {
      aircallCalls,
      aircallLoading,
      assignedTeamId,
      chayaConvoId,
      connectedAgents,
      conversationLoading,
      conversationMessages,
      creatingNote,
      hasActiveDeactivation,
      loading,
      newNoteText,
      notes,
      notesLoading,
      saving,
      savingNoteIds,
      savingTitle,
      selectedTagIds,
      state,
      suggestedReplies,
      suggestedRepliesLoading,
      tags,
      teams,
      ticket,
      visible,
      wsConnected,
    } = this.state;

    return (
      <CrmTicketModal
        aircallCalls={aircallCalls}
        aircallLoading={aircallLoading}
        assignedTeamId={assignedTeamId}
        chayaConvoId={chayaConvoId}
        connectedAgents={connectedAgents}
        conversationLoading={conversationLoading}
        conversationMessages={conversationMessages}
        creatingNote={creatingNote}
        hasActiveDeactivation={hasActiveDeactivation}
        loading={loading}
        newNoteText={newNoteText}
        notes={notes}
        notesLoading={notesLoading}
        onClose={this.hide}
        onCreateNote={this.onCreateNote}
        onDeleteNote={this.onDeleteNote}
        onNewNoteTextChange={this.onNewNoteTextChange}
        onRefreshSuggestedReplies={this.refreshSuggestedReplies}
        onSend={this.handleSend}
        onSendFile={this.handleSendFile}
        onApplyShortcutTags={this.onApplyShortcutTags}
        onStateChange={this.onStateChange}
        onTagToggle={this.onTagToggle}
        onTeamChange={this.onTeamChange}
        onTitleSave={this.onTitleSave}
        onWsConnect={this.handleWsConnect}
        onWsDisconnect={this.handleWsDisconnect}
        saving={saving}
        savingNoteIds={savingNoteIds}
        savingTitle={savingTitle}
        selectedTagIds={selectedTagIds}
        shortcuts={this.availableShortcuts()}
        state={state}
        suggestedReplies={suggestedReplies}
        suggestedRepliesLoading={suggestedRepliesLoading}
        tags={tags}
        teams={teams}
        ticket={ticket}
        userData={this.props.userData}
        visible={visible}
        wsConnected={wsConnected}
      />
    );
  }
}

export default connect((state) => ({
  userData: state.authorization.userData,
}))(subscriptionHOC(CrmTicketDetailsContainer));
